import { VehicleInfoData } from '../dtos';
import { ON_VEHICLE_INFO_UPDATED, SELECTION_METHOD_CHANGED, ON_VALID_VIN_DATA, ON_VIN_UPDATED, ON_INVALID_VIN_DATA, ON_RESET_VEHICLE_INFO, VEHICLE_INFO_UPDATE_VEHICLE_SELECTION_METHOD } from '../actions';
import manualSelectClicked from './operations/manualSelectClicked';
import vinChanged from './operations/vinChanged';
import resetVehicleInfo from './operations/resetVehicleInfo';
export function updateVehicleInfo(state = new VehicleInfoData(), action) {
    switch (action.type) {
        case ON_VEHICLE_INFO_UPDATED:
            return action.payload.vehicleInfo;
        case SELECTION_METHOD_CHANGED:
            return manualSelectClicked(state, action);
        case ON_VALID_VIN_DATA:
            const stateWithVin = vinChanged(state, action);
            if (action.payload.vid) {
                return Object.assign(Object.assign({}, stateWithVin), { Vid: action.payload.vid });
            }
            else {
                return stateWithVin;
            }
        case ON_VIN_UPDATED:
            return vinChanged(state, action);
        case ON_INVALID_VIN_DATA:
            return vinChanged(state, action);
        case ON_RESET_VEHICLE_INFO:
            return resetVehicleInfo(state, action);
        case VEHICLE_INFO_UPDATE_VEHICLE_SELECTION_METHOD: {
            return Object.assign(Object.assign({}, state), { VehicleSelectionMethod: action.payload.vehicleSelectionMethod });
        }
        default:
            return state;
    }
}
//# sourceMappingURL=updateVehicleInfo.js.map